import React from 'react';
import { get } from 'lodash';

import { useShowContext } from 'ui-builder';
import BaseFieldProps from './BaseFieldProps';

export interface TextFieldProps extends BaseFieldProps {
  noDataText?: string; // Text to show when no data is available
}

export default function TextField(props: TextFieldProps) {
  const context = useShowContext();

  let result;

  const noDataText = props.noDataText !== undefined ? props.noDataText : '-';

  if (props.source) {
    if (context?.data) {
      result = get(context.data, props.source) ?? noDataText;
    } else {
      result = noDataText;
    }
  } else {
    result = props.value;
  }

  return (<span className={props.className}>{result}</span>);
}
